import { h } from 'preact';
import { intcomma } from 'journalize';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { roundThousands } from '../election-utils';
import { select } from 'd3';

import DistrictStatsPrevResults from './DistrictStatsPrevResults';

class DistrictStats extends PureComponent {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      data: null,
      stats: null,
      raceData: null,
      turnoutData: null,
      bodyWidth: null,
      bodyWidth: null
    };
  }

  sortRaceData(data) {
    const raceData = [
      { race: "white", value: +data.white },
      { race: "Hispanic", value: +data.hispanic },
      { race: "Black", value: +data.black },
      { race: "Asian", value: +data.asian },
      // { race: "other", value: +data.other },
    ];
    raceData.sort((a, b) => b.value - a.value);
    raceData.forEach(d => {
      d.value = Math.round(d.value * 10) / 10;
    });

    return (raceData);
  }

  sortTurnoutData(data) {
    const turnoutData = [
      { party: "Republican", value: +data['2020_rp'], class: 'color-republican' },
      { party: "Democratic", value: +data['2020_dp'], class: 'color-democrat' },
    ]
    turnoutData.sort((a, b) => b.value - a.value)
    turnoutData.forEach(d => {
      d.value = Math.round(d. value * 10) / 10;
    })

    return (turnoutData);
  }

  fetchDistrict() {
    this.setState({ isLoading: false });
    const { slug, district } = this.props;

    // We first get the geometry (borders) and simplified geometries (borders for static images) for the previous 2020 districts
    getJSON(
      `${process.env.PUBLIC_PATH}api/${slug}-2020/${district}.json`
    ).then(geometry => {
      const raceData = this.sortRaceData(geometry.properties.stats);
      const turnoutData = this.sortTurnoutData(geometry.properties.stats);

      this.setState({
        isLoading: true,
        data: geometry.properties.stats,
        raceData: raceData,
        turnoutData: turnoutData
      });
    });
  }

  componentDidMount() {
    this.fetchDistrict();
  }

  componentDidUpdate(prevProps) {
    if (this.props.district !== prevProps.district) {
      this.fetchDistrict();
    }
  }

  render() {
    const { districtRace, slug, stats, name, district, note, width, bodyWidth } = this.props;
    const { isLoading, data, raceData, turnoutData } = this.state;

    if (!isLoading) return null;

    const districtUrl = `https://www.texastribune.org/directory/districts/${data.slug}/${district}`;

    return (
      <div class="district-stats">
        <p class="district-viewer__copy district-viewer__copytop">
          <a href={districtUrl} target="_blank">{name}{' District '}{district}</a> has about{' '}
          <span class="font-weight-bold">
            {intcomma(roundThousands(stats.total_vap))}
          </span>{' '}
          eligible voters.
        </p>
        <p class="district-viewer__copy">
          In this district, <span class="font-weight-bold">{raceData[0].value}%</span> of residents are {raceData[0].race}, <span class="font-weight-bold">{raceData[1].value}%</span> are {raceData[1].race}, <span class="font-weight-bold">{raceData[2].value}%</span> are {raceData[2].race} and <span class="font-weight-bold">{raceData[3].value}%</span> are {raceData[3].race}.
        </p>
        <p class="district-viewer__copy district-viewer__copybottom">
          In 2020, <span class="font-weight-bold">{Math.round(stats['total_g_turnout'] * 10) / 10}%</span> of registered voters cast a vote.
        </p>
        <div class="district-stats__prev-results">
          <DistrictStatsPrevResults
            district={district}
            slug={slug}
            stats={stats}
            width={width}
          />
        </div>
        <div class="district-note district-note__narrow">{note}</div>
      </div>
    );
  }
}

export default DistrictStats;